module.exports = __webpack_public_path__ + "img/card_arrow.073c297e.svg";